import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/eab70139-ae88-4186-a49f-f1d32113e78e";
export const REGISTER_URL = "https://a.ntrk2.com/0bdc1f8b-9ade-4b51-91a3-64f6800640bc";

export const LOGIN_URL_MAP = {};

export const REGISTER_URL_MAP = {};

export const FLOATING_BANNER_URL = "";

export const DOWNLOAD_URL = "https://wowlima.kzw2a.com/download?openExternalBrowser=1&id=jc2yg41dr1hq6c2";

export * from "./codes";
export * from "./context";
